module.exports = __webpack_public_path__ + "static/img/err-6.272c4c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/err-6.png
// module id = vNBx
// module chunks = 1